import { Check, Loader2, AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export type AutoSaveStatus = "saved" | "saving" | "unsaved" | "error";

interface AutoSaveIndicatorProps {
  status: AutoSaveStatus;
}

const STATUS_CONFIG: Record<
  AutoSaveStatus,
  { label: string; icon: typeof Check; className: string; iconClassName: string }
> = {
  saved: {
    label: "Guardado",
    icon: Check,
    className: "text-green-600",
    iconClassName: "text-green-500",
  },
  saving: {
    label: "Guardando...",
    icon: Loader2,
    className: "text-gray-500",
    iconClassName: "text-gray-400 animate-spin",
  },
  unsaved: {
    label: "Sin guardar",
    icon: AlertCircle,
    className: "text-yellow-600",
    iconClassName: "text-yellow-500",
  },
  error: {
    label: "Error al guardar",
    icon: AlertCircle,
    className: "text-red-600",
    iconClassName: "text-red-500",
  },
};

export function AutoSaveIndicator({ status }: AutoSaveIndicatorProps) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;

  return (
    <span className={cn("inline-flex items-center gap-1.5 text-xs", config.className)}>
      <Icon className={cn("w-3.5 h-3.5", config.iconClassName)} />
      {config.label}
    </span>
  );
}
